import credentials from "../assets/credentials";
import apiCallTemplate from "./config";

const { BASE_URL } = credentials;
const authURL = `${BASE_URL}/auth`;

//Registers
export const register = async (data) =>
  apiCallTemplate("post", `${authURL}/register`, data);
//Generate email registration code
export const generateRegistrationOtp = async (data) =>
  apiCallTemplate("post", `${authURL}/register/otp/generate`, data);

//verify registration email
export const verifyRegistrationOtp = async (data) =>
  apiCallTemplate("post", `${authURL}/register/otp/verify`, data);

//Login
export const login = async (data) =>
  apiCallTemplate("post", `${authURL}/login`, data);

//Update Password
export const updatePassword = async (data) =>
  apiCallTemplate("post", `${authURL}/update/password`, data);

//Generate otp
export const generateOtp = async (data) =>
  apiCallTemplate("post", `${authURL}/generate-otp`, data);

//Reset Password
export const resetPassword = async (data) =>
  apiCallTemplate("post", `${authURL}/password/reset`, data);

//Update Email
export const updateEmail = async (data) =>
  apiCallTemplate("put", `${authURL}/change/email`, data);

//Generate access token
export const generateAccessToken = async () =>
  apiCallTemplate("get", `${authURL}/refresh-token`);

//Logout user
export const logout = async () => apiCallTemplate("get", `${authURL}/logout`);
